module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "big2"
  }, [_c('strong', [_vm._v("She felt his fingers release the clip holding her hair, and as it fell about her shoulders Cherry jerked away.")])])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("‘Don’t,’ she said sharply, holding out her hand for the fastener. ‘It’s too hot to wear it down today.’")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("‘And is this the only reason you hide such beauty from me?’ he said, ignoring her outstretched fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("She stared at him, wondering if he was making fun of her. Her hair was ordinary. She was ordinary.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("‘My hair is nothing special.’ She fixed him with her most severe look. ‘And how I choose to wear it has absolutely nothing to do with you.’")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("He smiled faintly, which Cherry found incredibly irritating. ‘Do not deny once again there is not a man behind your sojourn in my country,’ he said with unforgivable audacity. ‘A man who is stupid enough to let you slip through his fingers does not deserve you anyway.’")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05b0cc3f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781460346471_epub_exc_r1.vue
// module id = 57
// module chunks = 0